class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');
        this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

        this.isMouseDown = false;

        document.addEventListener('mouseup', (e) => this.processBgRemoval(e, false));
        document.addEventListener('mousedown', (e) => this.processBgRemoval(e, true));
    }
    getMenuContainer() {
        return this.closest('.header__inline-menu');
    }
    processBgRemoval(e, isMouseDown) {
        requestAnimationFrame(() => {
            const menuContainer = this.getMenuContainer();
            const closestDetails = e.target instanceof Element ? e.target.closest('details') : null;

            this.isMouseDown = isMouseDown;

            if (!menuContainer) return;

            if ((!this.anyDetailsAreOpen() && closestDetails != this.mainDetailsToggle) || closestDetails == null) {
                menuContainer.classList.remove('header--megamenu-open');
            }
        });
    }
    onFocusOut() {
        requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }
    onToggle() {
        const menuContainer = this.getMenuContainer();

        if (!menuContainer) return;

        if (this.anyDetailsAreOpen()) {
            menuContainer.classList.add('header--megamenu-open');
        }
    }
    anyDetailsAreOpen() {
        const menuContainer = this.getMenuContainer();

        return menuContainer ? !!menuContainer.querySelector('details[open]') : false;
    }
    close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        const menuContainer = this.getMenuContainer();

        if(!this.anyDetailsAreOpen() && !this.isMouseDown) {
            if (menuContainer) {
                menuContainer.classList.remove('header--megamenu-open');
            }
        }
    }
}
customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
    constructor() {
        super();
        this.header = this.closest('.header-wrapper') || document.querySelector('.header-wrapper');
    }
    updateHeaderMegaMenuState() {
        if (!this.header) return;

        const hasOpenMegaMenu = !!this.header.querySelector('.header-bottom details.mega-menu[open]');
        this.header.classList.toggle('header-wrapper--mega-menu-open', hasOpenMegaMenu);
    }
    onToggle() {
        if (!this.header) return;

        this.header.preventHide = this.mainDetailsToggle.open;
        this.updateHeaderMegaMenuState();
        if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
        document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
    }
    close() {
        super.close();
        requestAnimationFrame(() => this.updateHeaderMegaMenuState());
    }
}
customElements.define('header-menu', HeaderMenu);